<template>
    <div v-show="AppDownloadShow">
        <!-- APP下载弹窗 -->
        <div class="fakemodal" v-if="ShowAPPBlock && SwitchToApp">
            <div class="content" style="width: 900px">
                <div class="modal-header">
                    <div class="title">用户端下载</div>
                    <div class="close" @click="closeDownload"></div>
                </div>
                <div class="modal-content">
                    <div class="modal-body download_modal">
                        <div class="box left">
                            <div class="qrcode">
                                <qrcode tag="img" :value="currentQrUrl" :options="QrcodeOptions"></qrcode>
                            </div>
                            <ul class="tabs">
                                <li :class="{ active: selectedTab === 'ios' }" @click="switchTab('ios')" v-if="iosUrl">
                                    IOS
                                </li>
                                <li
                                    :class="{ active: selectedTab === 'android' }"
                                    @click="switchTab('android')"
                                    v-if="androidUrl"
                                >
                                    Android
                                </li>
                            </ul>
                        </div>
                        <div class="box right">
                            <div v-if="selectedTab === 'ios'">
                                <h5>IOS用户端下载步骤</h5>
                                <div class="text">
                                    <p>1.使用扫码工具扫描上方二维码</p>
                                    <p>2.使用safari开启后在打开的页面允许描述档，再点击右上角安装</p>
                                    <p>3.请返回首页查看安装过程</p>
                                    <p>4.立即开启精采应用</p>
                                </div>
                            </div>
                            <div v-if="selectedTab === 'android'">
                                <h5>Android 用户端下载步骤</h5>
                                <div class="text">
                                    <p>1.使用扫码工具扫描上方二维码</p>
                                    <p>2.在打开的页面直接点击安装</p>
                                    <p>3.系统将自动为您下载应用程序</p>
                                    <p>4.下载完成后点选安装</p>
                                    <p>5.立即开启精采应用</p>
                                </div>
                            </div>
                            <button class="btns sec_btn" @click="closeDownload">关闭</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mask"></div>
        </div>
    </div>
</template>

<script>
import LoginPageDownload from 'XY/components/download/LoginPageDownload.js';

export default {
    name: 'AppDownload',
    mixins: [LoginPageDownload],
};
</script>
